import React from 'react';
import MaterialIconButton from 'material-ui/IconButton';

export default class IconButton extends React.PureComponent {
  render() {
    return (
      <MaterialIconButton
        className="ev-button ev-icon-button"
        tooltipStyles={{
          width: '250px',
          whiteSpace: 'normal',
          textAlign: 'left',
          fontSize: 'small',
          color: 'rgb(225, 255, 255)',
          opacity: '1',
          transition: 'none',
        }}
        {...this.props}
      />
    );
  }
}
